export default class MoreDisplayCard {
  constructor (moreDisplayCardBtnElem, showCardElements) {
    this.moreDisplayCardBtnElem = moreDisplayCardBtnElem;
    this.showCardElements = showCardElements;

    moreDisplayCardBtnElem.addEventListener('click', this.moreDisplayEvent.bind(this));
  }

  moreDisplayEvent (event) {
    event.preventDefault();

    Array.from(this.showCardElements).forEach((element) => {
      element.style.display = 'block';
    });

    this.moreDisplayCardBtnElem.parentNode.style.display = 'none';
  }
}
